import { render, staticRenderFns } from "./ArchivedProjectsPage.vue?vue&type=template&id=4afef04f&"
import script from "./ArchivedProjectsPage.vue?vue&type=script&lang=js&"
export * from "./ArchivedProjectsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports